import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class FileService {
  static uplaodFile(formData, parentId) {
    return HttpUtil.post(
      API_ROUTES.FILE.UPLOAD.replace("<containerId>", parentId),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data" 
        },
      }
    );
  }
  static downloadFile(fileId) {
    return HttpUtil.get(API_ROUTES.FILE.DOWNLOAD.replace("<fileId>", fileId), {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
}
